import { IServiceTransfersDto } from '@shared/api';
import { formats } from '@shared/utils';
import moment from 'moment-timezone';

export const formatTransferData = (key: string, transaction: IServiceTransfersDto) => {
    if (key === 'createdAt') {
        return moment(String(transaction[key])).format(formats.fullTime);
    }
    return transaction[key].toString();
};
